import styled from 'styled-components';
import { COLORS } from '@themes';

export const Style = styled.div`
  margin: 20px;
  margin-top: 30px;

  .head {
    color: ${COLORS.WHITE_1};
    font-weight: bold;
    font-size: 20px;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    .box {
      margin: 10px;
      flex: 1;
      min-width: 400px;
      transition: all 3s;
      .content {
        position: relative;
        height: 240px;
        text-align: center;
        padding: 30px;
        overflow: hidden;
        box-sizing: border-box;
        .img {
          width: 65px;
          height: 65px;
          border-radius: 50%;
          object-fit: contain;
        }
        .name {
          color: ${COLORS.GRAY_1};
          font-weight: 600;
          font-size: 20px;
          line-height: 24px;
          margin-top: 16px;
          max-height: 48px;
          white-space: pre-line;
          overflow: hidden;
        }
        .description {
          color: ${COLORS.GRAY_2};
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          margin-top: 4px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          text-overflow: ellipsis;
          word-break: break-word;
        }
      }
    }
  }
`;
